export class PrestadorProcedimento {
    id: number;
    procedimentoId: number;
    procedimentoNome: string;
    valorUnitario: number;
}
